import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { Modal } from '../../../../../components';
import type { ActionCardPayload } from './KnowledgeCard';
import { formatMetadataValue } from '../../utils/formatMetadata';
import { METADATA_FIELD_LABELS } from '../../utils/const';

const parseMetadataFields = (
  metadataFields: ActionCardPayload['metadata_fields']
): Record<string, unknown> => {
  if (!metadataFields) return {};

  if (typeof metadataFields === 'string') {
    try {
      const parsed = JSON.parse(metadataFields);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
        ? (parsed as Record<string, unknown>)
        : {};
    } catch {
      return {};
    }
  }

  return metadataFields;
};

export const KnowledgeMetadataModal = ({
  isOpenedShowMetadataModal,
  onCloseShowMetadataModal,
  actionPayload,
}: {
  isOpenedShowMetadataModal: boolean;
  onCloseShowMetadataModal: () => void;
  actionPayload: ActionCardPayload | null;
}) => {
  const parsedMetadata = parseMetadataFields(actionPayload?.metadata_fields);
  const metadataEntries = Object.entries(parsedMetadata);
  const hasMetadata = metadataEntries.length > 0;

  const metadataFields = metadataEntries.map(([key, value]) => {
    const label = METADATA_FIELD_LABELS[key] || key;
    const formattedValue = formatMetadataValue(value as string);

    return (
      <div key={key} className="w-full flex flex-col">
        <span className="text-medium font-semibold text-gray-500 whitespace-nowrap pb-2 block">
          {label}:
        </span>
        <div className="prose prose-sm max-w-none text-gray-500 text-tiny">
          {formattedValue ? (
            <Markdown remarkPlugins={[remarkGfm, remarkBreaks]}>
              {formattedValue}
            </Markdown>
          ) : (
            <span className="text-gray-400 italic">—</span>
          )}
        </div>
      </div>
    );
  });

  return (
    <Modal
      title="Metadata"
      open={isOpenedShowMetadataModal}
      onClose={onCloseShowMetadataModal}
      size="medium"
    >
      {hasMetadata ? (
        <div className="p-6 flex flex-col gap-4">{metadataFields}</div>
      ) : (
        <div className="p-6 flex flex-col gap-4  bg-gray-100 rounded-card">
          <span className="text-gray-400 text-medium">
            No metadata fields available
          </span>
        </div>
      )}
    </Modal>
  );
};
